export { default } from './Icona';
